export default __webpack_public_path__ + "static/media/Group8895.5c9b875a.svg";